import axios from 'axios';

export default axios.create({
    baseURL: 'https://charging-operator.baratsas.gr/api'
});
